import { useState, useEffect } from "react";

import { useQuery } from "@tanstack/react-query";
import { noop } from "neetocist";

import stickyRibbonsApi from "./api";
import { QUERY_KEYS, POLLING_INTERVAL, MAX_POLLING_TIME } from "./constants";

const { APP_STICKY_RIBBONS_LIST } = QUERY_KEYS;

const useFetchStickyRibbons = () => {
  const [isPolling, setIsPolling] = useState(false);

  useEffect(() => {
    if (!isPolling) return noop;

    const timer = setTimeout(() => {
      setIsPolling(false);
    }, MAX_POLLING_TIME);

    return () => {
      clearTimeout(timer);
    };
  }, [isPolling]);

  return useQuery({
    queryKey: [APP_STICKY_RIBBONS_LIST],
    queryFn: async () => {
      const response = await stickyRibbonsApi.fetchStickyRibbons();

      if (response.status === 202) {
        setIsPolling(true);
      } else if (response.status === 200) {
        setIsPolling(false);
      }

      return response.data;
    },
    refetchInterval: isPolling ? POLLING_INTERVAL : false,
  });
};

export { useFetchStickyRibbons };
